<h2 class="headline mb-4 flex items-center flex-none">
  <mat-icon class="mr-3 slc-color-brand" svgIcon="mat:add"></mat-icon>
  <span>Criar Card</span>
</h2>

<form [formGroup]="form" (submit)="onCriar()">
  <div class="flex-1 flex flex-col gap-4 mt-6">
    <!-- TIPO -->
    <mat-form-field>
      <mat-label>Tipo</mat-label>
      <mat-select formControlName="tipo">
        <mat-option [value]="tipoCard.LISTA">
          <mat-icon matPrefix [svgIcon]="iconsTipo[tipoCard.LISTA]"></mat-icon>
          Lista
        </mat-option>
        <mat-option [value]="tipoCard.GRAFICO_COLUNA">
          <mat-icon
            matPrefix
            [svgIcon]="iconsTipo[tipoCard.GRAFICO_COLUNA]"
          ></mat-icon>
          Gráfico Coluna
        </mat-option>
        <mat-option [value]="tipoCard.GRAFICO_LINHA">
          <mat-icon
            matPrefix
            [svgIcon]="iconsTipo[tipoCard.GRAFICO_LINHA]"
          ></mat-icon>
          Gráfico Linha
        </mat-option>
        <mat-option [value]="tipoCard.GRAFICO_PIZZA">
          <mat-icon
            matPrefix
            [svgIcon]="iconsTipo[tipoCard.GRAFICO_PIZZA]"
          ></mat-icon>
          Gráfico Pizza
        </mat-option>
      </mat-select>
      <mat-icon
        matPrefix
        [svgIcon]="
          form.controls.tipo.value ? iconsTipo[form.controls.tipo.value] : ''
        "
      ></mat-icon>
    </mat-form-field>

    <!-- TÍTULO -->
    <mat-form-field>
      <mat-label>Título</mat-label>
      <mat-icon matIconPrefix svgIcon="mat:label"></mat-icon>
      <input
        matInput
        formControlName="titulo"
        type="text"
        placeholder="Título&hellip;"
      />
      <mat-error>Campo Obrigatório</mat-error>
    </mat-form-field>

    <!-- DIMENSÕES: Colunas -->
    <mat-form-field>
      <mat-icon svgIcon="mat:stacked_bar_chart" matPrefix></mat-icon>
      <mat-label>Séries</mat-label>
      @if (form.controls.tipo.value === tipoCard.LISTA) {
      <mat-select formControlName="dimensoes" multiple>
        @for (dimensao of dimensoes(); track dimensao.id) {
        <mat-option [value]="dimensao">{{ dimensao.nome }} </mat-option>
        }
      </mat-select>
      } @else {
      <mat-select formControlName="dimensoes">
        @for (dimensao of dimensoes(); track dimensao.id) {
        <!-- Em gráficos de linhas apenas dimensões data são permitidas -->
        @if (form.controls.tipo.value !== tipoCard.GRAFICO_LINHA ||
        dimensao.tipoDado === 'data') {
        <mat-option [value]="dimensao">{{ dimensao.nome }} </mat-option>
        } }
      </mat-select>
      }
    </mat-form-field>

    <!-- DADOS ADICIONAIS -->
    @for (criterio of getCriteriosDadosAdicionais(); track $index) {
    <mat-form-field>
      <mat-icon svgIcon="mat:stacked_bar_chart" matPrefix></mat-icon>
      <mat-label>Dados Adicionais: {{ criterio.nome }}</mat-label>
      <mat-select multiple [formControl]="criterio.dadosAdicionaisSel">
        @for (dadoAdicional of criterio.dadosAdicionais; track $index) {
        <mat-option [value]="dadoAdicional.nomeTecnico"
          >{{ dadoAdicional.nome }}
        </mat-option>
        }
      </mat-select>
    </mat-form-field>
    }

    <!-- VALORES -->
    <mat-form-field>
      <mat-icon svgIcon="mat:stacked_bar_chart" matPrefix></mat-icon>
      <mat-label>Valores</mat-label>
      @if (form.controls.tipo.value !== tipoCard.GRAFICO_PIZZA) {
      <mat-select formControlName="valores" multiple>
        @for (valor of valores(); track $index) {
        <mat-option [value]="valor.id">{{ valor.nome }} </mat-option>
        }
      </mat-select>
      } @else {
      <mat-select formControlName="valores">
        @for (valor of valores(); track $index) {
        <mat-option [value]="valor.id">{{ valor.nome }} </mat-option>
        }
      </mat-select>

      }
    </mat-form-field>

    <!-- Submit / Cancelar -->
    <div class="flex-none flex justify-end items-end gap-2">
      <button mat-button type="button" (click)="sidebarComponent()?.close()">
        Cancelar
      </button>
      <button
        class="slc-btn-filled-brand"
        mat-flat-button
        [disabled]="form.untouched || form.invalid"
        type="submit"
      >
        Criar
      </button>
    </div>
  </div>
</form>
